import convertFormDataWithArray from '../../../utils/convertFormDataWithArray';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { ApiBaseResponse } from '../../type';
import type {
  AlarmDeleteParams,
  AlarmIsReadResponse,
  AlarmListParams,
  AlarmListResponse,
  AlarmReadParams,
} from './type';

export const fetchAlarmList = async (params: AlarmListParams) => {
  const searchParams = new URLSearchParams(
    Object.entries({
      ...params,
      limit: params.limit.toString(),
    }),
  );

  const res = await fetchExtended(`/v1/alarm/list?${searchParams}`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as AlarmListResponse;
};

export const fetchAlarmDelete = async (params: AlarmDeleteParams) => {
  const res = await fetchExtended('/v1/alarm/delete', {
    method: 'POST',
    credentials: 'include',
    body: convertFormDataWithArray(params),
  });
  const result = await res.json();
  return result as AlarmListResponse;
};

export const fetchAlarmRead = async (params: AlarmReadParams) => {
  const res = await fetchExtended('/v1/alarm/list_read', {
    method: 'POST',
    credentials: 'include',
    body: convertFormDataWithArray(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchAlarmIsRead = async () => {
  const res = await fetchExtended(`/v1/alarm/is_read`, {
    method: 'POST',
    credentials: 'include',
  });
  const result = await res.json();

  return result as AlarmIsReadResponse;
};
